import { initDisplay } from "./display/init";
import "./styles.css";

initDisplay();
